const articuloIsAlreadySelected = (
  articulosSelected = [],
  idToSearch: $TSMigrationFixMe
) => {
  const isAlreadySelected = articulosSelected?.some(
    // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
    (art) => art.id === idToSearch
  )

  return isAlreadySelected
}

const mapArticulo = ({
  articulo,
  articulosSelected,
  categoriaNombre,
}: $TSMigrationFixMe) => {
  const isAlreadySelected = articuloIsAlreadySelected(
    articulosSelected[categoriaNombre]?.articulos,
    articulo.id
  )

  return {
    ...articulo,
    selected: isAlreadySelected,
    categoriaNombre,
  }
}

export default mapArticulo
